<template>
  <div class="relationalDatabaseServiceResourceSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="5">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('RAM.common.PleaseSelectCompany')"
            :transfer="true"
            @on-change="changeCompanyID"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyIdList"
              :key="item.id"
              >{{ item.companyName }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="5">
        <Input
          v-model="accountName"
          :placeholder="$t('RAM.common.filterByAccountName')"
          @on-search="searchAccountName()"
        />
      </Col>
      <Col span="5">
        <Input
          v-model="name"
          :placeholder="
            $t('RAM.GCP.RelationalDataBaseResource.filterByInstanceName')
          "
        />
      </Col>
      <Col span="4">
        <Button
                    type="primary"
                    v-hasPermission="['resourceConfigurationManagement:gcp:relationalDatabaseServiceResourceGcp:page']"
                    @click="getData"
                    >{{ $t("message.select") }}</Button>
      </Col>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../../utils/cookieUtil.js";
import TableRelationalDatabaseServiceResourceGcp from "../rds/TableRelationalDatabaseServiceResourceGcp";

var tableRelationalDatabaseServiceResourceGcp =
  TableRelationalDatabaseServiceResourceGcp;
export default {
  name: "RelationalDatabaseServiceResourceGcpSearch",
  data() {
    return {
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      accountNameSearchKey: "",
      companyId: "",
      companyIdList: [],
      accountName: "",
      name: "",
    };
  },
  mounted: function () {
    if (this.company == 1) {
      this.listRegisterInformation();
    } else {
      // tableRelationalDatabaseServiceResourceGcp.methods.showAll();
    }
  },
  methods: {
    getData(){
      eventBus.$emit("name", this.name);
      eventBus.$emit("accountName", this.accountName);
      eventBus.$emit("companyId", this.companyId);
      tableRelationalDatabaseServiceResourceGcp.methods.showAll();
    },
    //查询公司
    listRegisterInformation: function () {
      this.$api.user.listRegisterInformation().then((res) => {
        // 获取公司列表数据
        this.companyIdList = res.data.companies;
        if (this.companyIdList) {
          this.companyId = this.companyIdList[0].id;
        }
        // this.searchCompany();
      });
    },
    // 切换公司
    changeCompanyID: function () {
      // this.searchCompany();
    },
    // 按公司搜索
    searchCompany: function () {
      eventBus.$emit("companyId", this.companyId);
      // tableRelationalDatabaseServiceResourceGcp.methods.showAll();
    },
    // 按账户名称查询
    searchAccountName: function () {
      eventBus.$emit("accountName", this.accountName);
      // tableRelationalDatabaseServiceResourceGcp.methods.showAll();
    },
    // 按实例名称查询
    searchName: function () {

    },
  },
};
</script>
<style scoped>
.relationalDatabaseServiceResourceSearch {
  padding: 4px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/gcp/rds/RelationalDatabaseServiceResourceGcpSearch.vue